import React from "react";
import { useTranslation } from "react-i18next";

import CustomPopup from "../CustomPopup";
import { CurrencyChangerContent } from "./components";

function CurrencyChanger({ visible, onClose, customOnChangeEvent = undefined }) {
  const { t } = useTranslation();

  return (
    <CustomPopup
      visible={visible}
      onClose={onClose}
      title={t("mobile.personal.menu.currency")}
      destroyOnClose={false}
    >
      <CurrencyChangerContent customOnChangeEvent={customOnChangeEvent} />
    </CustomPopup>
  );
}

export default CurrencyChanger;
